import { ROUTES, SITE_NAME } from '../Constants';
import cardImage1 from '../images/karkidaka-vavubali.webp';
import banner from '../images/rdps-banner.webp';
import googlePlayBadge from '../images/google-play-badge.png';

const HomePage = () => {
    return (
        <>
            <div>
                <div className='bg-orange-100'>
                    <div className='container mx-auto'>
                        <section className="flex flex-col-reverse lg:flex-row items-center justify-between px-6 py-16 lg:py-24">
                            <div className="lg:w-1/2 text-center lg:text-left">
                                <h1 className="text-2xl lg:text-4xl font-bold text-gray-800 mb-6 mt-2">
                                    Welcome to
                                </h1>
                                <h1 className='text-3xl lg:text-5xl font-bold text-gray-800 mb-6'>{SITE_NAME}</h1>
                                <p className="text-lg text-gray-600 mb-6 p-2">
                                    An organization working towards
                                    retaining the cultural and traditional values and
                                    rituals of Hindu Dharma. Though it was formally registered in 2014,
                                    its activities have been started since 2009.
                                </p>
                                <section className="flex flex-col items-center lg:items-start gap-4 py-5 lg:py-10">
                                    {/* App Download Row */}
                                    <div className="flex flex-col sm:flex-row items-center gap-4">
                                        <p className="text-xl font-bold text-orange-600">
                                            Download the App
                                        </p>

                                        <a href="https://play.google.com/store/apps/details?id=com.rsoft.comas&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                                            <img
                                                src={googlePlayBadge}
                                                alt="Get it on Google Play"
                                                className="w-44 hover:scale-105 transition-transform duration-200"
                                            />
                                        </a>
                                    </div>
                                    <a href={ROUTES.BHAGAVATHA_SAPTAH} className="bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-400 transition">
                                        Sreemadh Bhagavatha Saptah Nyana Yajnam
                                    </a>
                                    {/* Web Booking Row */}
                                    {/* <div className="flex flex-col sm:flex-row items-center gap-4">
                                        <p className="text-sm text-gray-500">
                                            Location for Karkidaka Vavubali
                                        </p>

                                        <a
                                            href="https://maps.app.goo.gl/fw7VWh2rCNwdQ2bD7"
                                            className="text-orange-500 px-5 py-2 rounded-lg hover:bg-orange-50 transition"
                                        >
                                            Location
                                        </a>
                                    </div> */}
                                </section>
                            </div>
                            <div className="lg:w-1/2">
                                <img
                                    src={banner}
                                    alt={SITE_NAME}
                                    className="rounded-lg shadow-lg object-cover"
                                />
                            </div>
                        </section>
                    </div>
                </div>
                {/* Hero Section */}
                <section className="bg-gray-100 py-20 px-10 text-center">
                    <div className='container mx-auto'>
                        <h1 className="text-4xl font-bold mb-4">Our Activities</h1>
                        <ul className='py-5'>
                            <li>Karkkitaka Vavubali & Pithru Tharppanam.</li>
                            <li>Financial and educational assistance to poor and needy children.</li>
                            <li>Financial and medical assistance to poor and needy one.</li>
                            <li>Hindu cultural events.</li>
                            <li>Promotion of traditional temple art forms.</li>
                        </ul>
                        <h1 className="text-4xl font-bold mb-4">Upcoming Event</h1>
                        <a href={ROUTES.BHAGAVATHA_SAPTAH} className="bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-400 transition">
                            Sreemadh Bhagavatha Saptah Nyana Yajnam
                        </a>
                    </div>
                </section>
                <div className='container mx-auto'>
                    <section className="flex flex-col-reverse lg:flex-row items-center justify-between px-6 py-16 lg:py-24">
                        <div className="lg:w-1/2">
                            <img
                                src={cardImage1}
                                alt="Karkidaka Vavubali"
                                className="rounded-lg shadow-lg object-cover"
                            />
                        </div>
                        <div className="lg:w-1/2 text-center py-2 mb-2">
                            <h1 className="text-2xl lg:text-4xl font-bold text-gray-800 mb-6">
                                Karkidaka Vavubali
                            </h1>
                            <p className="text-lg text-gray-600 mb-6 p-2 text-justify ml-2">
                                'Karkidaka Vavu Bali' is the name for the rituals performed by the Hindus in the state of Kerala for their deceased
                                ancestors. This day is also known as 'Vavu Bali' and is held in the month of 'Karkidakam' in the Malayalam
                                calendar. Karkidaka Vavu Bali is usually held on a day between July and August. The rituals start early morning at
                                6:00 am onwards. The ceremonies for deceased grandparents, parents, siblings, children, and relatives are performed
                                on 'Karutavavu' in the month of Karkidaka. The 'Shraddham' rituals must be done on river banks or seashore. In Kerala, the
                                'Shraddh' rituals done for the soul of the dead is known as 'Bali' and the new moon day or 'Amavasi' is referred to as 'Vavu', hence the name 'Vavu Bali'.
                            </p>
                            <a href={ROUTES.KARKIDAKAVAVUBALI} className="bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-400 transition">
                                Read More
                            </a>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default HomePage;